// Short quiz at the end of a "How to Use Resi" section. Same look as the Team Lead Certification quiz.
// Passing marks the quiz step complete in the agent's own training progress (users/<uid>/training/<moduleId>/<stepId>).
import React, { useState } from 'react';
import { ref, set } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { useAuth } from '../../context/AuthContext';
import { scoreSectionQuiz, SECTION_QUIZ_PASS } from '../../data/howToUseResiQuiz';

const btn = { backgroundColor: '#D4AF37', color: '#000', border: 'none', borderRadius: 6, padding: '10px 24px', cursor: 'pointer', fontWeight: 700, fontSize: 15, fontFamily: 'inherit' };

function SectionQuiz({ moduleId, stepId, quiz }) {
  const { user } = useAuth();
  const uid = user?.uid;
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const allAnswered = quiz.every((_, i) => answers[i] !== undefined);

  const submit = async () => {
    const r = scoreSectionQuiz(quiz, answers);
    setResult(r);
    setError('');
    if (!r.passed || !uid) return;
    try {
      await set(ref(database, `users/${uid}/training/${moduleId}/${stepId}`), { completedAt: new Date().toISOString(), score: r.score });
    } catch (e) {
      setError('Could not save your result. Check your connection and try again.');
    }
  };

  return (
    <div>
      {quiz.map((item, i) => {
        const picked = answers[i];
        return (
          <fieldset key={i} style={{ border: '1px solid #e5e5e5', borderRadius: 8, padding: '12px 16px', margin: '0 0 12px' }}>
            <legend style={{ fontWeight: 700, fontSize: 16, padding: '0 6px' }}>{i + 1}. {item.q}</legend>
            {item.options.map((opt, j) => {
              const show = result && (j === item.answer || j === picked);
              const color = !show ? 'inherit' : j === item.answer ? '#2f6f2f' : '#9b2c2c';
              return (
                <label key={j} style={{ display: 'block', fontSize: 15, lineHeight: 1.6, cursor: result ? 'default' : 'pointer', color }}>
                  <input type="radio" name={`${stepId}-q${i}`} disabled={!!result} checked={picked === j} onChange={() => setAnswers({ ...answers, [i]: j })} style={{ marginRight: 8 }} />
                  {opt}
                </label>
              );
            })}
          </fieldset>
        );
      })}
      {error && <div style={{ color: '#9b2c2c', marginBottom: 12 }}>{error}</div>}
      {!result && <button type="button" style={{ ...btn, opacity: allAnswered ? 1 : 0.4 }} disabled={!allAnswered} onClick={submit}>Submit quiz</button>}
      {result && (
        <div style={{ background: result.passed ? '#eef7ee' : '#fdf0f0', border: `1px solid ${result.passed ? '#9fc79f' : '#e3a5a5'}`, borderRadius: 8, padding: '12px 16px' }}>
          <p style={{ fontSize: 17, margin: '0 0 8px' }}>
            {result.passed
              ? `You passed with ${result.score}% (${result.correct} of ${result.total}). Nice work! Click Next to keep going.`
              : `You scored ${result.score}% (${result.correct} of ${result.total}). You need ${SECTION_QUIZ_PASS}% to pass. Look back over this section and try again.`}
          </p>
          <button type="button" style={btn} onClick={() => { setAnswers({}); setResult(null); }}>Retake quiz</button>
        </div>
      )}
    </div>
  );
}

// Training steps render Component with no props, so each quiz step gets its own bound component.
export const makeSectionQuiz = (moduleId, stepId, quiz) => {
  const Bound = () => <SectionQuiz moduleId={moduleId} stepId={stepId} quiz={quiz} />;
  Bound.displayName = `SectionQuiz(${stepId})`;
  return Bound;
};

export default SectionQuiz;
